import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Pokemon.css";
import { Ring } from 'ldrs/react';
import 'ldrs/react/Ring.css';

function Pokemon({ name }) {
  const [pokemonData, setPokemonData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://pokedex.mimo.dev/api/pokemon/${name}`
        );
        const data = await response.json();
        setPokemonData(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, [name]); // Ajout de 'name' comme dépendance

  if (loading) {
    return (
      <Ring 
        size="300" 
        stroke="20" 
        bgOpacity="0.1" 
        speed="2.7" 
        color="black" 
      />
    );
  }

  const PokemonStats = ({ stats }) => {
    return stats.map((stat) => (
      <div  className="info" key={stat.stat.name}>
        <p>
          {stat.stat.name}:
          <ul>
            <li>Value: {stat.base_stat}</li>
            <li>Effort: {stat.effort}</li>
          </ul>
        </p>
      </div>
    ));
  };

  return (
    <div>
      <Link to="/" className="back">
        {" "}
        Back
      </Link>
      <br />
      <div className="infoContainer">
        <h1 id="name">{pokemonData.name}</h1>
        <div className="images info">
          <div style={{float: "left"}}>
            Default:
            <br />
            <img
              src={pokemonData.sprites.front_default}
              alt={`${pokemonData.name} front`}
            />
            <img
              src={pokemonData.sprites.back_default}
              alt={`${pokemonData.name} back`}
            />
          </div>
          <div style={{float:"right"}}>
            Shiny:
            <br />
            <img
              src={pokemonData.sprites.front_shiny}
              alt={`${pokemonData.name} shiny front`}
            />
            <img
              src={pokemonData.sprites.back_shiny}
              alt={`${pokemonData.name} shiny back`}
            />
          </div>
        </div>
        <p className="info">Id: {pokemonData.id}</p>
        <p className="info">Order: {pokemonData.order}</p>
        <p className="info">Weight: {pokemonData.weight}</p>
        <p className="info">Height: {pokemonData.height}</p>
        <p className="info">Base Experience: {pokemonData.base_experience}</p>
        <PokemonStats stats={pokemonData.stats} />{" "}
      </div>
      {/* Passage des données de stats */}
    </div>
  );
}

export default Pokemon;
